import type { JSX } from 'react';

import { ACTIVITY_DOMAINS, DOMAIN_META } from '../../config/activity-display';
import type { ActivityCounts, ActivityDomain } from '../../model/activity';
import ActivityDomainChip from './ActivityDomainChip';

interface ActivityDomainFiltersProps {
  domain: ActivityDomain;
  counts: ActivityCounts | undefined;
  total: number | undefined;
  onDomainChange: (domain: ActivityDomain) => void;
}

const ActivityDomainFilters = ({ domain, counts, total, onDomainChange }: ActivityDomainFiltersProps): JSX.Element => (
  <div className="flex flex-wrap items-center gap-2" role="group" aria-label="Filtrar por dominio">
    <ActivityDomainChip
      active={domain === 'all'}
      label="Todas"
      count={counts?.all ?? total}
      onClick={() => onDomainChange('all')}
    />
    {ACTIVITY_DOMAINS.map((activityDomain) => {
      const meta = DOMAIN_META[activityDomain];

      return (
        <ActivityDomainChip
          key={activityDomain}
          active={domain === activityDomain}
          label={meta.label}
          icon={meta.icon}
          count={counts?.[activityDomain]}
          styles={meta}
          onClick={() => onDomainChange(activityDomain)}
        />
      );
    })}
  </div>
);

export default ActivityDomainFilters;
